import { useEffect, useState } from "react";
import { GetNoticeDetailsAnsweresForCompareByGroupIdAndCompanyFilter } from "../../services/GroupService";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useSelector } from "react-redux";
import { getMyPosition } from "../../features/position/positionSlice";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";
import { GetNoticeById } from "../../services/NoticeService";
import ConvertToShamsiWithOut330 from "../../extentions/convertors/ConvertToShamsiWithOut330";
import { Button } from "primereact/button";
import { Button as AButton } from "antd";
import { GetPositionById } from "../../services/PositionService";
import { number } from "yup";
import { numberToWords } from "@persian-tools/persian-tools";

const CompareTableReportVer2 = () => {
  const [result, setResult] = useState<any>(null);

  const convertToWords = (originalNumber: number) => {
    try {
      //console.log("originalNumber", originalNumber);

      const wordsResult = numberToWords(originalNumber);
      console.log(wordsResult);

      setResult(wordsResult);
    } catch (error) {
      console.error("Error converting to words:", error);
      setResult(null); // or provide a default value or handle the error in a different way
    }
  };

  function getQueryStringValue(key: any) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  }

  interface DataTypeCompany {
    key: React.Key;
    companyId: string;
    name: string;
    count: string;
    sumPrice: string;
    sumPriceWithVat: string;
    answeredItemsCount: string;
    totalItemsCount: string;
  }

  const [GetCompareData, SetCompareData] = useState<DataTypeCompany[]>([]);
  const [GetNotice, SetNotice] = useState<any>();
  const [GetPosition, SetPosition] = useState<any>();

  useEffect(() => {
    console.log("GetNotice", GetNotice);

    if (
      GetNotice?.responsiblePositionId !== null &&
      GetNotice?.responsiblePositionId !== undefined
    ) {
      GetPositionById(GetNotice?.responsiblePositionId).then((p) => {
        //console.log(p.data);

        SetPosition(p.data);
      });
    }
  }, [GetNotice]);

  // Example usage
  useEffect(() => {
    console.log("GetCompareData", GetCompareData);

    if (
      GetCompareData[0] !== null &&
      GetCompareData[0] !== undefined &&
      GetNotice?.noticeDetails[0]?.count !== undefined &&
      GetNotice?.noticeDetails[0]?.count !== null
    ) {
      convertToWords(
        Number(Math.round(Number(GetCompareData[0]?.sumPriceWithVat)))
      );
    }
  }, [GetCompareData]);
  useEffect(() => {
    const selectedRowKeys = getQueryStringValue("selectedRowKeys");
    const noticeId = getQueryStringValue("noticeId");
    GetNoticeById(noticeId).then((p: any) => {
      console.log("dds", p.data);
      SetNotice(p.data);
    });

    GetNoticeDetailsAnsweresForCompareByGroupIdAndCompanyFilter(
      noticeId,
      selectedRowKeys
    ).then((p) => {
      console.log(p.data.data);
      SetCompareData(
        p.data.data.sort((a: any, b: any) => a.sumPrice - b.sumPrice)
      );
    });
    //console.log("Selected Row Keys:", selectedRowKeys?.split(","));
    // console.log("noticeId:", noticeId);
  }, []);
  interface CustomCellRendererProps {
    record: any; // Replace 'RecordType' with the actual type of your data
    dataIndex: string;
  }
  const PriceAntdCellRendrer: React.FC<CustomCellRendererProps> = ({
    record,
    dataIndex,
  }) => {
    return (
      <span>
        {record.sumPrice
          .toString()
          ?.replace(/[^0-9]/g, "")
          ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </span>
    );
  };
  const DateTimeCellRendrer: React.FC<CustomCellRendererProps> = ({
    record,
    dataIndex,
  }) => {
    return (
      <span style={{ fontSize: "0.7rem" }}>
        {ConvertToShamsi(record.lastOfferDate)}
      </span>
    );
  };

  const columnsNotice: ColumnsType<any> = [
    {
      title: "موضوع آگهی",
      dataIndex: "title",
      key: "title",
      width: "20%",
    },
    {
      title: "تاریخ انتشار",
      dataIndex: "dateString",
      key: "dateString",
      width: "20%",
    },
  ];
  const columnsTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "فروشگاه",
      dataIndex: "name",
      key: "name",
      width: "30%",
      //   render:(text: string, record: any) => (
      // 	<CustomCellRenderer record={record} dataIndex="companyId" />
      //   ),
      //...getColumnSearchProps("name"),
    },
    {
      title: "تعداد اقلام  ",
      dataIndex: "count",
      key: "count",
      width: "20%",
    },
    {
      title: "قیمت کل",
      dataIndex: "sumPrice",
      key: "sumPrice",
      width: "20%",
      render: (text: string, record: any) => (
        <PriceAntdCellRendrer record={record} dataIndex="companyId" />
      ),
    },
    {
      title: "آخرین پیشنهاد",
      dataIndex: "lastOfferDate",
      key: "lastOfferDate",
      width: "20%",
      render: (text: string, record: any) => (
        <DateTimeCellRendrer record={record} dataIndex="companyId" />
      ),
    },
  ];
  const handlePrint = () => {
    window.print();
  };
  return (
    <>
      {GetCompareData[0] !== null &&
      GetCompareData[0] !== undefined &&
      GetNotice?.noticeDetails[0]?.count !== undefined &&
      GetNotice?.noticeDetails[0]?.count !== null ? (
        <>
          {" "}
          <div className="col-11" style={{ textAlign: "left", margin: "auto" }}>
            <AButton
              style={{
                backgroundColor: "green",
                color: "white",
                height: "3rem",
                width: "6rem",
                fontSize: "1.5rem",
              }}
              className="no-print my-2"
              onClick={handlePrint}
            >
              پرینت
            </AButton>
            <div className="col-12 my-4" style={{ textAlign: "center" }}>
              <table className="border table table-bordered  ">
                <tr>
                  <td
                    className="boder col-2 p-1"
                    style={{ textAlign: "right" }}
                  ></td>
                  <td className="col-6 border">
                    <b>
                      {/* مصوبات کارگروه معاملات فروشگاه
                      {GetPosition?.company?.name} */}
                      گزارش استعلام قیمت سامانه دیجیتال آگهی
                    </b>
                  </td>
                  <td
                    className="boder col-2 p-1"
                    style={{ textAlign: "right" }}
                  >
                    کد مدرک:
                  </td>
                </tr>
              </table>
              <p style={{ fontSize: "0.70rem" }}>
                بدین وسیله گواهی میشود با توجه به درخواست خرید شماره 1 از 3 نفر
                از فروشندگان و تامین کنندگان به صورت کتبی استعلام گردید .
                خواهشمند است مصوبه لازم جهت خرید و عقد قرارداد را اعلام فرمایید
                .
              </p>
            </div>

            <div>
              <table className="border col-12" style={{ textAlign: "center" }}>
                <tr>
                  <th>مشخصات کالا و خدمات</th>
                  <th colSpan={2}>پیشنهاد دهنده اول</th>
                  <th colSpan={2}>پیشنهاد دهنده دوم</th>
                  <th colSpan={2}>پیشنهاد دهنده سوم</th>
                </tr>
                <tr>
                  <td rowSpan={3}>{GetNotice?.title} </td>
                  <td colSpan={2}>{GetCompareData[0]?.name}</td>
                  <td colSpan={2}>{GetCompareData[1]?.name}</td>
                  <td colSpan={2}>{GetCompareData[2]?.name}</td>
                </tr>
                <tr>
                  <td>قیمت ناخالص</td>
                  <td>قیمت خالص</td>
                  <td>قیمت ناخالص</td>
                  <td>قیمت خالص</td>
                  <td>قیمت ناخالص</td>
                  <td>قیمت خالص</td>
                </tr>
                <tr>
                  <td>
                    {Math.round(Number(GetCompareData[0]?.sumPriceWithVat))
                      .toString()
                      ?.replace(/[^0-9]/g, "")
                      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {Number(GetCompareData[0]?.sumPrice)
                      .toString()
                      ?.replace(/[^0-9]/g, "")
                      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {Math.round(Number(GetCompareData[1]?.sumPriceWithVat))
                      .toString()
                      ?.replace(/[^0-9]/g, "")
                      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {Number(GetCompareData[1]?.sumPrice)
                      .toString()
                      ?.replace(/[^0-9]/g, "")
                      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {Math.round(Number(GetCompareData[2]?.sumPriceWithVat))
                      .toString()
                      ?.replace(/[^0-9]/g, "")
                      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {Number(GetCompareData[2]?.sumPrice)
                      .toString()
                      ?.replace(/[^0-9]/g, "")
                      ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                </tr>
                <tr>
                  <td className="px-1" style={{ textAlign: "right" }}>
                    تعداد اقلام تامین کننده :
                  </td>
                  <td colSpan={2}>{GetCompareData[0]?.count}</td>
                  <td colSpan={2}>{GetCompareData[1]?.count}</td>
                  <td colSpan={2}>{GetCompareData[2]?.count}</td>
                </tr>
                <tr>
                  <td className="px-1" style={{ textAlign: "right" }}>
                    تعداد واحد:
                  </td>
                  <td colSpan={2}>
                    {GetCompareData[0]?.answeredItemsCount !== undefined ? (
                      <>
                        {GetCompareData[0]?.answeredItemsCount} از{" "}
                        {GetCompareData[0]?.totalItemsCount}{" "}
                      </>
                    ) : (
                      <></>
                    )}
                  </td>
                  <td colSpan={2}>
                    {GetCompareData[1]?.answeredItemsCount !== undefined ? (
                      <>
                        {GetCompareData[1]?.answeredItemsCount} از{" "}
                        {GetCompareData[1]?.totalItemsCount}{" "}
                      </>
                    ) : (
                      <></>
                    )}
                  </td>
                  <td colSpan={2}>
                    {GetCompareData[2]?.answeredItemsCount !== undefined ? (
                      <>
                        {GetCompareData[2]?.answeredItemsCount} از{" "}
                        {GetCompareData[2]?.totalItemsCount}{" "}
                      </>
                    ) : (
                      <></>
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="p-1" style={{ textAlign: "right" }}>
                    جمع کل :
                  </td>
                  <td colSpan={6}> {result} ریال</td>
                </tr>
                <tr style={{ textAlign: "right" }}>
                  <td className="p-1">شرایط تسویه :</td>
                  <td colSpan={6}> </td>
                </tr>
                <tr style={{ textAlign: "right" }}>
                  <td className="p-1"> تاریخ تحویل :</td>
                  <td colSpan={6}> </td>
                </tr>
                <tr style={{ textAlign: "right" }}>
                  <td className="p-1"> شرایط پرداخت : </td>
                  <td colSpan={6}> </td>
                </tr>
              </table>
            </div>

            {/* <Table
          size="small"
          dataSource={GetCompareData}
          pagination={false}
          columns={columnsTotal}
          bordered
        /> */}

            <div
              className="col-12 "
              style={{
                position: "fixed",
                bottom: "0",
                textAlign: "center",
                width: "92%",
                margin: "auto",
              }}
            >
              <table className="border col-12">
                <tr>
                  <td
                    style={{
                      padding: "8px",
                      height: "100px",
                      textAlign: "right",
                    }}
                  >
                    ملاحظات
                  </td>
                  <td colSpan={6}></td>
                </tr>
                <tr style={{ textAlign: "right" }}>
                  <td
                    style={{
                      padding: "8px",
                    }}
                  >
                    نام و امضاء دبیر کارگروه :
                  </td>
                  <td
                    style={{
                      padding: "8px",
                    }}
                  >
                    نام و امضاء عضو کارگروه :
                  </td>
                  <td
                    style={{
                      padding: "8px",
                    }}
                  >
                    نام و امضاء عضو کارگروه :
                  </td>
                  <td
                    style={{
                      padding: "8px",
                    }}
                  >
                    نام و امضاء رئیس کارگروه :
                  </td>
                </tr>
                <tr style={{ textAlign: "right" }}>
                  <td
                    style={{
                      padding: "8px",
                      height: "150px",
                    }}
                  ></td>
                  <td
                    style={{
                      padding: "8px",
                    }}
                  ></td>
                  <td
                    style={{
                      padding: "8px",
                    }}
                  ></td>
                  <td
                    style={{
                      padding: "8px",
                    }}
                  ></td>
                </tr>
              </table>
            </div>
          </div>{" "}
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default CompareTableReportVer2;
